<template>
    <div class="preview-body">
        <div v-if="!showPageLoader">
            <div class="customer-info">
                <div class="customers-info-section">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="filter-section sub-filter">
                                <div class="row sup-heading">
                                    <div class="col-md-12 sup-heading-content">
                                        <h2 class="m-0">Preview Profile</h2>
                                        <b-button
                                            size="sm"
                                            variant="secondary"
                                            @click="pdf"
                                        >
                                            Export as PDF
                                        </b-button>
                                    </div>
                                </div>
                            </div>
                            <hr />
                            <ul>
                                <li>
                                    <div class="seprator-section">
                                        <div class="row">
                                            <div
                                                v-for="(field, index) in fields"
                                                v-if="
                                                    field.section ==
                                                    'setup-profile'
                                                "
                                                :key="index"
                                                :class="{
                                                    [field.class]: true,
                                                    'col-lg-12':
                                                        field.type == 'heading',
                                                    'col-md-6':
                                                        field.type !==
                                                            'heading' &&
                                                        !field.class,
                                                    'col-md-8':
                                                        (index == 4 ||
                                                            index == 6) &&
                                                        section ==
                                                            'account-info',
                                                }"
                                            >
                                                <div
                                                    v-if="
                                                        field.type == 'heading'
                                                    "
                                                >
                                                    <h3>{{ field.label }}</h3>
                                                </div>
                                                <div v-else>
                                                    <hr
                                                        v-if="
                                                            [
                                                                'multi-text-field',
                                                                'multi-field',
                                                            ].includes(
                                                                field.type
                                                            )
                                                        "
                                                    />

                                                    <div
                                                        v-if="
                                                            [
                                                                'multi-text-field',
                                                                'multi-field',
                                                            ].includes(
                                                                field.type
                                                            )
                                                        "
                                                        class="row"
                                                    >
                                                        <div class="col-md-12">
                                                            <label>{{
                                                                showLabel(field)
                                                            }}</label>
                                                        </div>
                                                        <div class="col-md-12">
                                                            <ul
                                                                v-for="(
                                                                    item,
                                                                    subIndex
                                                                ) in field.multiOptions"
                                                                class="row"
                                                            >
                                                                <li
                                                                    class="col-md-6"
                                                                >
                                                                    <label>{{
                                                                        showLabel(
                                                                            item
                                                                        )
                                                                    }}</label>
                                                                </li>
                                                                <li
                                                                    class="col-md-6"
                                                                >
                                                                    <span
                                                                        class=""
                                                                        >{{
                                                                            showValue(
                                                                                customerDetails,
                                                                                field,
                                                                                item
                                                                            )
                                                                        }}</span
                                                                    >
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <ul v-else class="row">
                                                        <li class="col-md-6">
                                                            <label>{{
                                                                showLabel(field)
                                                            }}</label>
                                                        </li>
                                                        <li class="col-md-6">
                                                            <span class="">{{
                                                                showValue(
                                                                    customerDetails,
                                                                    field
                                                                )
                                                            }}</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <hr
                                                    v-if="
                                                        [
                                                            'multi-text-field',
                                                            'multi-field',
                                                        ].includes(field.type)
                                                    "
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <div class="seprator-section"  v-if="this.configData.accountinfo != false">
                                        <div class="row">
                                            <div
                                                v-for="(field, index) in fields"
                                                v-if="
                                                    field.section ==
                                                        'account-info' &&
                                                    field.type !=
                                                        'sourceofwealth-evidence' &&
                                                    field.type !=
                                                        'sourceoffunds-evidence' 
                                               
                                                "
                                                :key="index"
                                                :class="{
                                                    [field.class]: true,
                                                    'col-lg-12':
                                                        field.type == 'heading',
                                                    'col-md-6':
                                                        field.type !==
                                                            'heading' &&
                                                        !field.class,
                                                    'col-md-8':
                                                        (index == 4 ||
                                                            index == 6) &&
                                                        section ==
                                                            'account-info',
                                                }"
                                            >
                                                <div
                                                    v-if="
                                                        field.type == 'heading'
                                                    "
                                                >
                                                    <h3>{{ field.label }}</h3>
                                                </div>
                                                <div v-else>
                                                    <!--<hr v-if="['multi-text-field', 'multi-field'].includes(field.type)">-->

                                                    <div
                                                        v-if="
                                                            [
                                                                'multi-text-field',
                                                                'multi-field',
                                                            ].includes(
                                                                field.type
                                                            )
                                                        "
                                                        class="row"
                                                    >
                                                        <div class="col-md-12">
                                                            <label>{{
                                                                showLabel(field)
                                                            }}</label>
                                                        </div>
                                                        <div class="col-md-12">
                                                            <ul
                                                                v-for="(
                                                                    item,
                                                                    subIndex
                                                                ) in field.multiOptions"
                                                                class="row"
                                                            >
                                                                <li
                                                                    class="col-md-6"
                                                                >
                                                                    <label>{{
                                                                        showLabel(
                                                                            item
                                                                        )
                                                                    }}</label>
                                                                </li>
                                                                <li
                                                                    class="col-md-6"
                                                                >
                                                                    <span
                                                                        class=""
                                                                        >{{
                                                                            showValue(
                                                                                customerDetails,
                                                                                field,
                                                                                item
                                                                            )
                                                                        }}</span
                                                                    >
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <ul v-else class="row">
                                                        <li class="col-md-6">
                                                            <label>{{
                                                                showLabel(field)
                                                            }}</label>
                                                        </li>
                                                        <li class="col-md-6">
                                                            <span class="">{{
                                                                showValue(
                                                                    customerDetails,
                                                                    field
                                                                )
                                                            }}</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <hr
                                                    v-if="
                                                        [
                                                            'multi-text-field',
                                                            'multi-field',
                                                        ].includes(field.type)
                                                    "
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <div class="seprator-section">
                                        <div class="row">
                                            <div
                                                v-for="(field, index) in fields"
                                                v-if="
                                                    field.section ==
                                                    'additional-info'
                                                "
                                                :key="index"
                                                :class="{
                                                    [field.class]: true,
                                                    'col-lg-12':
                                                        field.type == 'heading',
                                                    'col-md-6':
                                                        field.type !==
                                                            'heading' &&
                                                        !field.class,
                                                }"
                                            >
                                                <div
                                                    v-if="
                                                        field.type == 'heading'
                                                    "
                                                >
                                                    <h3>{{ field.label }}</h3>
                                                </div>
                                                <div v-else>
                                                    <!--<hr v-if="['multi-text-field', 'multi-field'].includes(field.type)">-->

                                                    <div
                                                        v-if="
                                                            [
                                                                'multi-text-field',
                                                                'multi-field',
                                                            ].includes(
                                                                field.type
                                                            )
                                                        "
                                                        class="row"
                                                    >
                                                        <div class="col-md-12">
                                                            <label>{{
                                                                showLabel(field)
                                                            }}</label>
                                                        </div>
                                                        <div class="col-md-12">
                                                            <ul
                                                                v-for="(
                                                                    item,
                                                                    subIndex
                                                                ) in field.multiOptions"
                                                                class="row"
                                                            >
                                                                <li
                                                                    class="col-md-6"
                                                                >
                                                                    <label>{{
                                                                        showLabel(
                                                                            item
                                                                        )
                                                                    }}</label>
                                                                </li>
                                                                <li
                                                                    class="col-md-6"
                                                                >
                                                                    <span
                                                                        class=""
                                                                        >{{
                                                                            showValue(
                                                                                customerDetails,
                                                                                field,
                                                                                item
                                                                            )
                                                                        }}</span
                                                                    >
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <ul v-else class="row">
                                                        <li class="col-md-6">
                                                            <label>{{
                                                                showLabel(field)
                                                            }}</label>
                                                        </li>
                                                        <li class="col-md-6">
                                                            <span class="">{{
                                                                showValue(
                                                                    customerDetails,
                                                                    field
                                                                )
                                                            }}</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <hr
                                                    v-if="
                                                        [
                                                            'multi-text-field',
                                                            'multi-field',
                                                        ].includes(field.type)
                                                    "
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                            <ul v-if="configData.documentUpload == true">
                                <li>
                                    <div class="seprator-section">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <h3>ID Document</h3>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div
                                                class="col-lg-4 col-md-6 col-sm-12 col-xs-12 mb-4"
                                            >
                                                <img
                                                    v-if="
                                                        identityInfo.fileName &&
                                                        identityInfo.fileName
                                                            .split('.')
                                                            .pop() === 'pdf'
                                                    "
                                                    v-authenticated-image="
                                                        'customer-documents/pdf_icon.png'
                                                    "
                                                    style="
                                                        min-width: 40% !important;
                                                        width: 10%;
                                                    "
                                                />

                                                <img
                                                    v-else
                                                    v-authenticated-image="
                                                        'customers/' +
                                                        identityInfo.fileName
                                                    "
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <div class="seprator-section">
                                        <div class="row">
                                            <div class="col-md-6 mb-4">
                                                <vue-signature></vue-signature>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="buttons">
                <b-button
                    size="sm"
                    class="mr-3"
                    variant="secondary"
                    @click="$router.go(-1)"
                >
                    Back
                </b-button>
                <b-button
                    type="button"
                    variant="primary"
                    class="primary-add-btn"
                    @click="onSubmitContinue"
                    >CONTINUE
                </b-button>
            </div>

            <b-modal
                ref="termsandconditionmodal"
                size="xl"
                title="Terms And Conditions"
                hide-footer
                :click-to-close="false"
                :no-close-on-backdrop="true"
                :no-close-on-esc="true"
            >
                <terms-and-condition
                    @agreed="agreeToTermsAndConditions"
                ></terms-and-condition>
            </b-modal>
            <b-modal
                ref="otpmodal"
                size="sm"
                title=""
                hide-footer
                :click-to-close="false"
                :no-close-on-backdrop="true"
                :no-close-on-esc="true"
            >
                <otp-modal
                    v-if="is_data_fetched"
                    :data="otpData"
                    heading="Verify your OTP (One Time Password)"
                    @verificationStatus="otpResponse"
                    @reSendOTP="reSendOTP"
                ></otp-modal>
            </b-modal>
            <div class="col-lg-4"></div>
            <!-- <b-modal
        ref="my-modal"
        size="lg"
        title=""
        hide-footer
        :click-to-close="false"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
    >
        <modal-setup-profile @close="handleClose"> </modal-setup-profile>
    </b-modal> -->
        </div>
        <base-table-spinner v-if="showPageLoader"></base-table-spinner>
    </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import moment from 'moment'
import TermsAndCondition from '@/components/registration/TermsAndCondition.vue'
import OtpModal from '@/components/registration/OtpModal.vue'
// import ModalSetupProfile from '@/components/registration/ModalSetupProfile.vue'
import request from '@/utils/request'
import _ from 'lodash'
import VueSignature from '@/components/BaseSignature.vue'

export default {
    components: {
        TermsAndCondition,
        OtpModal,
        VueSignature,
        // ModalSetupProfile,
    },
    filters: {},
    data() {
        return {
            country: process.env.VUE_APP_COUNTRY,
            fields: [],
            customerDetails: [],
            basicInfo: [],
            residentialInfo: [],
            declarationByCustomer: [],
            pepDeclaration: [],
            ultimateBenefit: [],
            factaDetails: [],
            otpData: null,
            is_data_fetched: false,
            sourceOfWealth: [],
            sourceOfFunds: [],
            identityInfo: null,
            state_emirates_province: '',
            instance: process.env.VUE_APP_COUNTRY,
            configData: [],
            showPageLoader: true,
        }
    },
    /*
  |--------------------------------------------------------------------------
  | Component > computed
  |--------------------------------------------------------------------------
  */
    computed: {
        // ...mapState({
        //     userOcr: (state) => state.registration.useOcr,
        // }),

        ...mapGetters(['dataSegmentId', 'loading', 'form']),

        dataSegmentId() {
            if (this.$route.params.dataSegmentId) {
                return this.$route.params.dataSegmentId
            }
            return this.$store.getters.dataSegmentId
        },
    }, // End of Component > computed

    /*
  |--------------------------------------------------------------------------
  | Component > watch
  |--------------------------------------------------------------------------
  */

    created() {
        this.configData = this.$store.state.configData
        this.customerDetails = this.$store.state.registration.form
        // this.setValues()
        this.getRecords()

        this.identityInfo = this.$store.getters.getField(
            'documentInfo.identity'
        )
    },
    mounted() {},
    methods: {
        checkField(field)
        {
            let excludeFields = ['occupationInfo.relationshipStartDate',
                'enhancedDueDiligence','accountInfo.enhancedDueDiligence.dateOfEdd',
                'accountInfo.enhancedDueDiligence.isScrutinyPerformed','accountInfo.enhancedDueDiligence.isCustBusInquired',
                'accountInfo.enhancedDueDiligence.isManagementApproval','accountInfo.enhancedDueDiligence.isFirstPayment',
                'accountInfo.enhancedDueDiligence.scrutinyRemarks','accountInfo.enhancedDueDiligence.custBusInquiredRemarks',
                'accountInfo.enhancedDueDiligence.managementApprovalRemarks','accountInfo.enhancedDueDiligence.firstPaymentRemarks',
                'documentInfo.scrutiny.fileName','documentInfo.custBusInquired.fileName','documentInfo.managementApproval.fileName',
                'documentInfo.firstPayment.fileName',
                'strInformation','accountInfo.isStr','accountInfo.strDate','accountInfo.strReason','faceToFaceDeclaration','accountInfo.isf2f']
            const fieldFound = excludeFields.find(fieldObj => fieldObj === field.key);
            if(fieldFound)
            {
                return false
            }
            if(field.status && field.status=='active')
            {
                if(field.visibleTo && field.visibleTo.indexOf('company') > -1)
                {
                    return true
                }
            }
            return false
        },
        showLabel(field, index = '') {
            if (this.customerDetails.type == 'company') {
                if (field.key == 'basicInfo.firstName') {
                    return 'Company Name'
                }
                if (field.key == 'identityInfo.number') {
                    if (process.env.VUE_APP_COUNTRY_TEMP == 'UK') {
                        return 'Company Registration Number'
                    }
                    else if(process.env.VUE_APP_COUNTRY_TEMP == "PK"){
                        return 'NTN number / Registration Number'
                    }
                    return 'Company Registration / Trade License Number'
                }
                if (field.key == 'identityInfo.passport.number') { 
                       if(process.env.VUE_APP_COUNTRY_TEMP == "PK"){
                           return 'CUIN Number / Registration Number'
                       }
                }
                if (field.key == 'basicInfo.dateOfBirth') {
                    return 'Date of Incorporation'
                }
                if (field.key == 'identityInfo.expiryDate') {
                    if (process.env.VUE_APP_COUNTRY_TEMP == 'UK') {
                        return 'Company Registration Expiry'
                    }
                    return 'Company Registration / Trade License expiry date'
                }
                if (
                    field.key == 'basicInfo.nationalityId' ||
                    field.label == 'Nationality'
                ) {
                    return 'Country of Operation'
                }
                if (
                    field.key == 'basicInfo.countryOfResidenceId' ||
                    field.label == 'Country of Residence'
                ) {
                    return 'Country of Domicile'
                }
                if (field.key == 'basicInfo.hasOtherNationalities') {
                    return 'Do you operate in other countries?'
                }
                if (field.key == 'identityInfo.isLifetimeExpiry') {
                    return 'Do you have a Company Reg expiry date?'
                }
                if (field.key == 'basicInfo.otherNationalities') {
                    return 'Specify other countries'
                }
                if (field.key == 'sourceOfFunds.OtherEvidenced') {
                    return "Enter details of Company's Source of Funds"
                } else {
                    return field.label
                }
            } else {
                return field.label
            }
        },
        showValue(customerDetails, field, subItem = '') {
            if (field.type == 'multi-field') {
                let temp = customerDetails.dynamicInputValues[field.key]
                    ? customerDetails.dynamicInputValues[field.key]
                    : []
                let childKey = subItem.key
                if (temp.length > 0) {
                    const values = temp.map((obj) =>
                        this.showValue(
                            obj,
                            field.multiOptions.find((el) => el.key == childKey)
                        )
                    )
                    return values.join(', ')
                }
                return 'N/A'
            }
            // console.log('customer details',customerDetails)
            if ('multi-text-field' == field.type) {
                let temp = customerDetails.dynamicInputValues[field.key]
                    ? customerDetails.dynamicInputValues[field.key]
                    : []
                let tempKey = subItem.key
                if (temp.length > 0) {
                    const values = temp.map((obj) => obj[tempKey])
                    return values.join(', ')
                }
                return 'N/A'
            }
            let fieldName = field.key
            if (field.isAssociation) {
                field.key = field.key.replace('Id', '')
            }
            let value = customerDetails[fieldName]
                ? customerDetails[fieldName]
                : ''

            if (field.key.includes('.')) {
                fieldName = field.key.split('.')
                if (fieldName.length > 2) {
                    value = _.get(customerDetails, field.key)
                        ? _.get(customerDetails, field.key)
                        : ''
                } else {
                    value = customerDetails[fieldName[0]]
                        ? customerDetails[fieldName[0]][fieldName[1]]
                        : ''
                }
            }

            if (value != '' && value != null && value != undefined) {
                if (field.type == 'date-picker') {
                    value = this.$moment(value).format('MMM D, Y')
                }
                if (
                    ( field.type == 'other-nationalities' ||
                    field.type == 'multi-select' ) && (Array.isArray(value) && value.length > 0 )
                ) {
                    if(value[0].title) 
                    {
                        value = value.map((item) => item.title).join(', ')
                    }else{
                        value = value.map((item) => item.text).join(', ')
                    }
                }
                // if(field.isAssociation)
                // {
                //     // value= this.fetchTitle(field.association,value)
                //     Promise.resolve(this.fetchTitle(field.association, value))
                //         .then(resolvedValue => {
                //             value = resolvedValue;
                //             return value
                //         })
                //         .catch(error => {
                //             console.log(error);
                //         });
                // }
                if (field.type == 'phone-number') {
                    if (fieldName.length > 2) {
                        return (
                            customerDetails[fieldName[0]][fieldName[1]][
                                'isdCode'
                            ] +
                            ' ' +
                            value
                        )
                    }
                    return (
                        customerDetails[fieldName[0]]['isdCode'] + ' ' + value
                    )
                }

                return value
            }
            return 'N/A'
        },
        async getRecords() {
            try {
                let { data } = await request({
                    url: `/form-builder/fields`,
                    params: {
                        dataSegmentId: this.dataSegmentId,
                        visibleTo: this.$store.getters.form.type,
                        isEdit:false,
                        type:this.$store.getters.form.type,
                        uaepassfield:this.configData.uaepassfield
                    },
                })
                this.showPageLoader = false
                this.fields = data.data
            } catch (error) {
                console.log(error)
            }
            this.$store.commit('setLoading', false)
        },
        handleClose(event) {
            this.$refs['my-modal'].hide()
        },
        editSetupProfile() {
            this.$refs['my-modal'].show()
            // this.$ref.modalEditProfile.show()
            // if (this.$route.meta.publicRegistration === true) {
            //     this.$router.push({
            //         name: 'public-registration-setup-profile-edit',
            //         params: {
            //             dataSegmentId: this.dataSegmentId,
            //         },
            //     })
            // } else {
            //     // this.$router.push('/register-customer/finish')
            //     alert('Error in Opening Setup Profile Edit')
            // }
        },
        onSubmitContinue() {
            let result = false
            if (
                !this.$store.getters.form.signature.sign ||
                !this.$store.getters.form.signature.agree
            ) {
                this.$store.commit(
                    'setError',
                    'Please agree the signature terms'
                )
            } else {
                result = true
            }
            if (result) {
                let otpResp = {
                    verificationStatus: true,
                }
                this.$store.commit('setLoading', false)
                // console.log('uaepas----',this.$store.getters.form.uaePassDetails)
                if(this.$store.getters.form.uaePassDetails && this.$store.getters.form.uaePassDetails.firstnameEN)
                {
                    this.otpResponse(otpResp)
                }
            else {
                    this.$refs.termsandconditionmodal.show()
                    // this.sendOPT()
                }
                // if (this.$route.path.includes('deep')) {
                //
                // } else {
                //     this.otpResponse(otpResp)
                // }
            }
        },
        agreeToTermsAndConditions() {
            // this.$refs.termsandconditionmodal.hide()
            this.sendOPT()
        },
        async sendOPT() {
            try {
                // console.log("Full :"+JSON.stringify(this.$store.state.registration.form) )
                let phoneNumber =
                    this.$store.state.registration.form.contactInfo.phoneNumber
                let fullName =
                    this.$store.state.registration.form.basicInfo.firstName
                let email =
                    this.$store.state.registration.form.contactInfo.email

                this.$store.commit('setLoading', true)
                // let phoneNumber = '923333728009'
                // console.log('PHONE NUMBER: ' + phoneNumber)

                const formData = {
                    mobileNo: phoneNumber,
                    name: fullName,
                    email: email,
                }
                const { data } = await request({
                    url: `/configurations/generate-otp/`,
                    method: 'post',
                    data: formData,
                })

                if (data) {
                    this.is_data_fetched = true
                    data.data.phoneNumber = phoneNumber
                    this.otpData = data

                    this.$refs.termsandconditionmodal.hide()
                    this.$refs.otpmodal.show()
                }

                this.showPageLoader = false
                // console.log('Response OTP data: ' + JSON.stringify(data))
                // this.fields = data.data
            } catch (error) {
                console.log('OTP error: ' + error)
            }

            this.$store.commit('setLoading', false)
        }, // End of sendOtp() method

        async otpResponse(otpResponse) {
            if(otpResponse && ((otpResponse.token && otpResponse.otp) || otpResponse.verificationStatus===true))
            {
                this.$store.commit('setLoading', true)

                let registrationUrl = '/customers/non-face-to-face'
                try {
                    var formData = this.$store.state.registration.form
                    formData.dataSegmentId = this.dataSegmentId
                    formData.ipLocationDetails = this.$store.state.registration.ipLocationDetails
                    formData.otp=otpResponse.otp
                    formData.token=otpResponse.token

                    await this.updateKeys()
                    let encryptedForm = this.$encrypt(formData)
                    const tempRequest = { data: encryptedForm}
                    const { data } = await request({
                        url: registrationUrl,
                        method: 'post',
                        data: tempRequest,
                    })

                    console.log('-----resp',data)
                    this.$store.commit('updateField', {
                        key: 'idenfoId',
                        value: data.data.idenfoId,
                    })
                    if (data.warning) {
                        this.$store.commit('setValue', {
                            key: 'warning',
                            value: data.warning,
                        })
                    }
                    this.$refs.otpmodal.hide()
                    this.$store.commit('setLoading', false)
                    this.$router.push({
                        name: 'deep-registration-finish',
                        params: {
                            dataSegmentId: this.dataSegmentId,
                            source: this.$route.params.source,
                        },
                    })
                } catch (errors) {
                    console.log('-----errors----',errors)

                    let err = errors
                    if(errors.errors)
                    {
                        let allErrors = JSON.parse(JSON.stringify(errors.errors))
                        let errorsArray = []
                        for (var key in allErrors) {
                            if (allErrors.hasOwnProperty(key)) {
                                errorsArray.push(allErrors[key].message)
                            }
                        }
                        err = errorsArray[0]
                    }

                    this.$store.commit('setLoading', false)
                    this.$store.commit('setError', err)
                }
            }
            else {
                this.$store.commit('setLoading', false)
                this.$store.commit('setError', "Could not get OTP")
            }
        }, // End of otpResponse() method

        async updateKeys()
        {
            // Update Fields Source of funds/wealth Docs
            this.$store.commit('updateField', {
                key: 'documentInfo.fundsEvidenceDocument',
                value: this.$store.getters.getField(
                    'sourceOfFunds.evidenceDocument'
                ),
            })
            this.$store.commit('updateField', {
                key: 'documentInfo.wealthEvidenceDocument',
                value: this.$store.getters.getField(
                    'sourceOfWealth.evidenceDocument'
                ),
            })

            let eddKeysToDelete = ['accountInfo.enhancedDueDiligence','documentInfo.scrutiny','documentInfo.custBusInquired',
                'documentInfo.managementApproval','documentInfo.firstPayment',]
            for(let i=0 ; i < eddKeysToDelete.length ; i++){
                this.$store.commit('updateField', {
                    key: eddKeysToDelete[i],
                    value: null,
                })
            }

        },
        async reSendOTP() {
            this.sendOPT()
        }, // End of reSendOTP() method

        addDangerClass(date) {
            let expiryDate = this.$moment(date)
            let diff = expiryDate.diff(this.$moment(), 'days')
            if (diff <= 60) {
                return 'danger'
            }
            return ''
        },
        onCloseOTPModal() {
            this.$store.commit('setLoading', false)
        },
        pdf() {
            window.print()
            // window.close()
        },
        setValues() {
            this.pepDeclaration.push(
                {
                    field: 'DO YOU CURRENTLY HOLD ANY PUBLIC POSITION?',
                    value:
                        this.customerDetails &&
                        this.customerDetails.pepDeclaration &&
                        this.customerDetails.pepDeclaration.anyPublicPos
                            ? this.customerDetails.pepDeclaration.anyPublicPos
                            : 'N/A',
                },
                {
                    field: 'DID YOU HOLD ANY PUBLIC POSITION IN THE LAST 12 MONTHS?',
                    value:
                        this.customerDetails &&
                        this.customerDetails.pepDeclaration &&
                        this.customerDetails.pepDeclaration.posLastTwoMonths
                            ? this.customerDetails.pepDeclaration
                                  .posLastTwoMonths
                            : 'N/A',
                },
                {
                    field: 'HAVE YOU EVER HELD ANY PUBLIC POSITION?',
                    value:
                        this.customerDetails &&
                        this.customerDetails.pepDeclaration &&
                        this.customerDetails.pepDeclaration.everPublicPosition
                            ? this.customerDetails.pepDeclaration
                                  .everPublicPosition
                            : 'N/A',
                },
                {
                    field: 'DID YOU HAVE OR HAVE YOU EVER HAD ANY DIPLOMATIC IMMUNITY?',
                    value:
                        this.customerDetails &&
                        this.customerDetails.pepDeclaration &&
                        this.customerDetails.pepDeclaration.diplomaticImmunity
                            ? this.customerDetails.pepDeclaration
                                  .diplomaticImmunity
                            : 'N/A',
                },
                {
                    field: 'DO YOU HAVE A RELATIVE WHO HAS HELD ANY PUBLIC POSITION IN THE LAST 12 MONTHS?',
                    value:
                        this.customerDetails &&
                        this.customerDetails.pepDeclaration &&
                        this.customerDetails.pepDeclaration.relativeTwelveMonths
                            ? this.customerDetails.pepDeclaration
                                  .relativeTwelveMonths
                            : 'N/A',
                },
                {
                    field: 'DO YOU HAVE A CLOSE ASSOCIATE WHO HAS HELD ANY PUBLIC POSITION IN THE LAST 12 MONTHS?',
                    value:
                        this.customerDetails &&
                        this.customerDetails.pepDeclaration &&
                        this.customerDetails.pepDeclaration
                            .closeAssociateTwelveMonths
                            ? this.customerDetails.pepDeclaration
                                  .closeAssociateTwelveMonths
                            : 'N/A',
                },
                {
                    field: 'HAS THERE BEEN A CONVICTION AGAINST YOU BY A COURT OF LAW?',
                    value:
                        this.customerDetails &&
                        this.customerDetails.pepDeclaration &&
                        this.customerDetails.pepDeclaration.conviction
                            ? this.customerDetails.pepDeclaration.conviction
                            : 'N/A',
                },
                {
                    field: 'IF YOU HAVE ANSWERED "YES" TO ANY OF THE QUESTIONS ABOVE, PLEASE PROVIDE DETAILS:',
                    value:
                        this.customerDetails &&
                        this.customerDetails.pepDeclaration &&
                        this.customerDetails.pepDeclaration.other
                            ? this.customerDetails.pepDeclaration.other
                            : 'N/A',
                }
            )
            this.sourceOfWealth.push(
                {
                    field: 'SOURCE OF WEALTH - EACH ITEM CHECKED SHOULD BE APPROPRIATELY EVIDENCED',
                    value:
                        this.customerDetails &&
                        this.customerDetails.sourceOfWealth &&
                        this.customerDetails.sourceOfWealth.evidenced
                            ? this.customerDetails.sourceOfWealth.evidenced
                            : 'N/A',
                },
                {
                    field: 'IF OTHER SOURCE OF FUNDS',
                    value:
                        this.customerDetails &&
                        this.customerDetails.sourceOfWealth &&
                        this.customerDetails.sourceOfWealth.OtherEvidenced
                            ? this.customerDetails.sourceOfWealth.OtherEvidenced
                            : 'N/A',
                }
            )
            this.sourceOfFunds.push(
                {
                    field: 'SOURCE OF WEALTH - EACH ITEM CHECKED SHOULD BE APPROPRIATELY EVIDENCED',
                    value:
                        this.customerDetails &&
                        this.customerDetails.sourceOfFunds &&
                        this.customerDetails.sourceOfFunds.evidenced
                            ? this.customerDetails.sourceOfFunds.evidenced
                            : 'N/A',
                },
                {
                    field: 'IF OTHER SOURCE OF FUNDS',
                    value:
                        this.customerDetails &&
                        this.customerDetails.sourceOfFunds &&
                        this.customerDetails.sourceOfFunds.OtherEvidenced
                            ? this.customerDetails.sourceOfFunds.OtherEvidenced
                            : 'N/A',
                }
            )
        },
    },
}
</script>
